import React, { useMemo } from "react";
import ResiduesItem from "./residuesItem";

// For Fake order
export default function Residues({ order_rows }) {
  const order_rows_rebuild = useMemo(() => {
    let residuesItem = [];
    order_rows.forEach((item) => {
      if (item.product_info) {
        const filteredResi = item.product_info.product_suppliers.filter(
          (filt) => filt.quantity > 0
        );
        filteredResi.forEach((each) => {
          residuesItem.push({
            ...each,
            originalTitle: item.product_name,
            originalCode: item.product_reference,
          });
        });
      }
    });
    return residuesItem;
  }, [order_rows.length, order_rows]);

  if (order_rows_rebuild.length == 0)
    return <div className="text-bold">There are no products left</div>;

  return (
    <div className="table-responsive">
      <table className="table">
        <tbody>
          {order_rows_rebuild.map((item) => (
            <ResiduesItem key={item.id} item={item} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
